export const click = (x,y) => {
    if(x && y)
        (global as any).document?.elementFromPoint(x, y)?.click();
};